import axios from 'axios';

// Get API endpoint from environment variable, with fallback to localhost for development.
// When REACT_APP_USE_BETA_API is set, use a relative URL so setupProxy can forward to the beta API.
export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.videoplussensors.com/api'
    : process.env.REACT_APP_USE_BETA_API === 'true'
      ? '/api'
      : 'http://localhost:8080/api');

export const axiosInstance = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
});

export const convertStringJsonToObject = (stringJson) => JSON.parse(stringJson.toString());
